import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import DatePeriodPicker from '@/components/common/dateperiodpicker/DatePeriodPicker.vue'

const defaultEl = {
  id: null,
  material_group: null,
  from_date_period_id: null,
  to_date_period_id: null,
  type: null,
  value: '',
  reportSubcode: null
};

export default {
  name: 'ClientMaterialGroupSettingEdit',
  props: {
    clientApiId: String
  },
  data () {
    return {
      editEl: defaultEl,
      loading: false
    }
  },
  components: {
    DatePeriodPicker
  },
  validations: {
    editEl: {
      material_group: { required },
      from_date_period_id: { required }
    }
  },
  computed: {
    ...mapState(['config']),
    getTitle () {
      if (this.editEl && this.editEl.id) {
        return this.$t('menu.clients.materialgroupsetting.edit');
      }
      return this.$t('menu.clients.materialgroupsetting.new');
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-clients');
    },
    materialGroupOptions () {
      return this.$store.getters.getConfigOptions('material_groups', this.$i18n.locale);
    },
    reportOptions () {
      return this.ZPFormatHelper.getReportNameOptions(false, true);
    }
  },
  methods: {
    show (elData) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.editEl.material_group = this.$store.getters.getParamFromConfig('material_groups', this.editEl.material_group_id, 'code');
      this.editEl.type = this.$store.getters.getParamFromConfig('client_setting_types', this.editEl.type_id, 'code');
      this.editEl.valuepercent = (this.editEl.value ? (parseFloat(this.editEl.value) * 100).toFixed(2) : this.editEl.value);
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const self = this;
        const reqData = {};
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
        }
        reqData.value = (this.editEl.valuepercent ? (parseFloat(this.editEl.valuepercent) / 100).toFixed(4) : null);
        const path = 'client/single/' + this.clientApiId + '/material-settings/edit';
        this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, { 'material-settings': reqData }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
